import type { Point } from "@pdfking/math"

import type { Matrix } from "#public"

/** The point `p` seen through `matrix`, in the matrix's own space. */
export const MatrixApply = <T extends number>(
  [a, b, c, d, e, f]: Matrix<T>,
  { x, y }: Point<T>
): Point<T> => ({
  x: (a * x + c * y + e) as T,
  y: (b * x + d * y + f) as T,
})
